import { CDNImage } from '../../common/interfaces/cdnImage';
import { TaskListProgressBarStyleConfig } from '../../taskList/interfaces';
import { EventConfig } from './eventConfig';

interface ButtonStyle {
  textColor: string;
  fillColor: string;
  outlineColor: string;
  hoverFillColor: string;
  hoverOutlineColor: string;
  hoverTextColor: string;
  text?: string;
}

export interface TimeLineStyle {
  lineColor: string | null;
  iconContainerColor: string | null;
  iconColor: string | null;
}

export interface TemplateUtilityLink {
  label: string;
  url: string;
}
export interface UtilityBarStyle {
  backgroundColor: string;
  textColor: string;
  logo: CDNImage | null;
}
export interface FooterStyle {
  backgroundColor: string;
  textColor: string;
  helpButton: ButtonStyle;
}
export interface PageStyle {
  backgroundColor: string;
  containerColor: string;
  backgroundImage: CDNImage | null;
  fontType: string;
  fontColor: string;
  buttonStyle1: ButtonStyle;
  buttonStyle2: ButtonStyle;
  flexibleBanner: boolean;
  primaryColor?: string;
  secondaryColor?: string;
  terniaryColor?: string;
  quaternaryColor?: string;
  taskListTitleColor?: string;
  taskListSectionColor?: string;
  timeline: TimeLineStyle;
  progressBar?: TaskListProgressBarStyleConfig;
}

interface MuiInputBase {
  backgroundColor: string;
}

interface Error {
  color: string;
}
interface MuiLink {
  color: string;
}

interface PlaceHolder {
  color: string;
}
interface ProgressIconColor {
  fillColor: string;
  strokeColor: string;
}

export interface PasswordStrengthMeter {
  weak: { color: string };
  medium: { color: string };
  strong: { color: string };
  border: string;
}

interface AlertOutlined {
  background?: string;
  border: string;
}

export interface Alert {
  outlinedInfo: AlertOutlined;
  outlinedInfoTransparent: AlertOutlined;
  outlinedError: AlertOutlined;
  outlinedSuccess: AlertOutlined;
}

interface Divider {
  backgroundColor: string;
}

export interface SvgStyles {
  stroke: string;
  fill: string;
  fillForElements: string;
}

interface MuiSvgIcon {
  iconColor: string;
}
export interface BasicTaskListIcons {
  lockAndCompleted: { color: string };
}
export interface DialogBox {
  primaryColor: string;
  secondaryColor: string;
  border: string;
  opacity: number;
}
interface Success {
  color: string;
}

interface MuiButton {
  disabledBackgroundColor: string;
  disabledTextColor: string;
}

export interface IconHover {
  background: string;
  color?: string;
}
interface OtherElements {
  svgStyles: SvgStyles;
  basicTaskListIcons: BasicTaskListIcons;
  MuiSvgIcon: MuiSvgIcon;
  alert: Alert;
  divider: Divider;
  passwordStrengthMeter: PasswordStrengthMeter;
  MuiInputBase: MuiInputBase;
  error: Error;
  MuiLink: MuiLink;
  PlaceHolder: PlaceHolder;
  disabledColor: string;
  border: string;
  borderColor: string;
  borderColorInputField: string;
  ProgressIconColor: ProgressIconColor;
  dialogBox: DialogBox;
  success: Success;
  MuiButton: MuiButton;
  iconHover: IconHover;
}
export interface TemplateSettings {
  requiresLogin: boolean;
  utilityBar: UtilityBarStyle;
  links: TemplateUtilityLink[];
  footer: FooterStyle;
  page: PageStyle;
  mfsEnabled?: boolean;
  otherElements: OtherElements;
  event?: EventConfig;
}

export enum TemplateLayout {
  TEMPLATE_LAYOUT_01 = 'TEMPLATE_LAYOUT_01', // Tiled
  TEMPLATE_LAYOUT_02 = 'TEMPLATE_LAYOUT_02', // Journey
  TEMPLATE_LAYOUT_03 = 'TEMPLATE_LAYOUT_03', // Launchpad
  TEMPLATE_LAYOUT_04 = 'TEMPLATE_LAYOUT_04', // Event
}

export enum TemplateType {
  EXPERIENCE_LITE = 'experience_lite',
  BASIC_EXPERIENCE_LITE = 'basic_experience_lite',
}

export interface Template {
  layoutCode: TemplateLayout;
  id: string;
  type: TemplateType;
  status: string;
  firstWorkflowItemId: string;
  companyId: number;
  settings: TemplateSettings;
}
